// Store listings for the separate "Цагийн ажил" (daily-pay part-time) mobile app.
// Shared by the /parttime-app guide page and the popup shown on entering the site.
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=hr.oneplace.parttime";
export const APP_STORE_URL = "https://apps.apple.com/us/app/ajil-%D1%86%D0%B0%D0%B3%D0%B8%D0%B9%D0%BD-%D0%B0%D0%B6%D0%B8%D0%BB/id6776153004";

// TEMPORARY, for reviewing the popup's design: while true, ParttimeAppPopup shows for
// admins too. Either way it shows at most once per page load (see ParttimeAppPopup).
export const PARTTIME_POPUP_PREVIEW = true;
